module.exports = __webpack_public_path__ + "3e7ea40567d203bb3b6417b840755212.ttf";


//////////////////
// WEBPACK FOOTER
// ./client/assets/fonts/RobotoCondensed-LightItalic.ttf
// module id = 507
// module chunks = 0